import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import {
  CustomFieldTypes,
  OrganizationCustomFieldsWithPaginationDto,
  UpdateCustomFieldByPhonebookCommand,
} from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { CustomField } from '../../../../core/api/models/custom-field';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { PhonebookCustomFieldsService } from './../../../../core/api/services/phonebook-custom-fields.service';
import { CommonModule } from '@angular/common';
import { BaseFormModule } from 'src/app/shared/components/base/base-component/base-form.module';

@Component({
    selector: 'app-phonebook-custom-fields-form',
    templateUrl: './phonebook-custom-fields-form.component.html',
    styleUrls: ['./phonebook-custom-fields-form.component.scss'],
    imports: [BaseFormModule]
})
export class PhonebookCustomFieldsFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  pageVocabs = 'pages.phonebook.customFieldsForm.';
  title: string;
  model: UpdateCustomFieldByPhonebookCommand = {};
  values: any[];

  @Input('phonebookId') input_phonebookId: number;
  @Input('customFields') input_model: CustomField[] = [];

  get CustomFieldTypes() {
    return CustomFieldTypes;
  }

  //#endregion

  constructor(protected currentService: PhonebookCustomFieldsService) {
    super();
  }

  ngOnInit() {
    try {
      this.initForm();
      this.model.phonebookId = this.input_phonebookId;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    try {
      if (changes['input_model']) {
        this.model.customFields = Object.assign({}, this.input_model);
        if (this.input_model.length > 0) this.formPageConfig.isEditMode = true;
        else this.formPageConfig.isEditMode = false;
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  initForm() {
    this.form = new FormGroup({});
  }

  //#region Api

  //Create
  baseCreateApi(model: UpdateCustomFieldByPhonebookCommand) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .phonebookCustomFieldsUpdateCustomFieldByPhonebookPut({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  baseUpdateApi(model: UpdateCustomFieldByPhonebookCommand) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .phonebookCustomFieldsUpdateCustomFieldByPhonebookPut({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  getCustomFields(event: OrganizationCustomFieldsWithPaginationDto[]) {
    try {
      this.model.customFields = event.map((item) => {
        return {
          fieldType: item.fieldType,
          nameEn: item.nameEn,
          nameFa: item.nameFa,
          value: '',
        };
      });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  onReset() {
    //this.model.customFields = Object.assign({}, this.input_model);
    this.model = {};
  }
}
